import ActionTypes from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const afterThreeTries = () => {
  return {
    type: ActionTypes.REST_FAILURE_COUNT,
  };
};
